import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import ProductOffers from "./ProductOffers.js";
const ProductOffersContainer = ({ labels: labelsProp, ...props }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => labelsProp ?? {
      title: getLabel("products.offers.title")
    },
    [getLabel, labelsProp]
  );
  return /* @__PURE__ */ React.createElement(ProductOffers, { ...props, labels });
};
export {
  ProductOffersContainer as default
};
//# sourceMappingURL=ProductOffersContainer.js.map
